var publicPath = __webpack_public_path__;
                    module.exports = {
                        symbol: publicPath + 'sprite.svg#logo-initials',
                        view: publicPath + 'sprite.svg#view-logo-initials',
                        viewBox: '0 0 52 55',
                        title: 'sigle',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };